import React from 'react'
import NewServices from './NewService'

const OurServices = () => {
  return (
    <>
    <NewServices/>
    </>
  )
}

export default OurServices